import QAResumeRepository from "../../repositories/qa_resume.repository";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/error.entity";

interface Props {
    qaResumeRepository: QAResumeRepository;
}

export default class DownloadAllQAResumeUseCase {
    private _qaResumeRepository: QAResumeRepository;

    constructor(_: Props) {
        this._qaResumeRepository = _.qaResumeRepository;
    }

    public call = async (_: { humanAgentId?: string, from?: Date, to?: Date }): Promise<Either<ErrorEntity, void>> => {
        return this._qaResumeRepository.downloadAll(_);
    };
}

export const DownloadAllQAResumeUseCaseName = "DownloadAllQAResumeUseCase";